var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.595 1.582L11.417.404a1.382 1.382 0 00-1.952 0l-.461.46 3.13 3.131.461-.46a1.38 1.38 0 000-1.953z",
    fill: "url(#pencil_svg__paint0_linear_7677_7343)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.559 9.566L.006 12.55a.38.38 0 00.444.444l2.984-.553L.559 9.566z",
    fill: "url(#pencil_svg__paint1_linear_7677_7343)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.465 1.403L.97 8.9l3.13 3.13 7.495-7.496-3.13-3.13z",
    fill: "url(#pencil_svg__paint2_linear_7677_7343)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pencil_svg__paint0_linear_7677_7343",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pencil_svg__paint1_linear_7677_7343",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pencil_svg__paint2_linear_7677_7343",
    x1: 6.5,
    y1: 0,
    x2: 6.5,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62E61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD5630"
  })))));
}
export default __webpack_public_path__ + "static/pencil.475d2f87.svg";
export { SvgPencil as ReactComponent };